<main
  [style]="
    data.theme === 'dark'
      ? 'background-color: #373534; color: #ffffff'
      : 'background-color: #F7F7F7; color: black'
  "
>
  <mat-dialog-content>
    <div class="d-flex flex-column gap-2 text-black">
      <div class="d-flex justify-content-between mb-2">
        <span class="lead fw-bold">{{ 'equipment' | i18next }}</span>
        <span mat-dialog-close>
          <mat-icon>close</mat-icon>
        </span>
      </div>
      <ul>
        <li *ngFor="let optional of data.equipment">
          <span class="text-muted">{{ optional.description }}</span>
        </li>
      </ul>
    </div>
  </mat-dialog-content>
</main>
